import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../utils.service'
import { RuntimeService } from '../runtime.service'
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.css']
})
export class AdminPageComponent implements OnInit {
  private tp: string;
  private id: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rts: RuntimeService,
    public utils: UtilsService
  ) {
    this.rts.resetAdminType()
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.tp = params['tp']
      this.id = params['id']
      /*try {
        if (this.id && this.isEditCriterion)
          this.target = this.cs.get(this.id)
        } catch (e) {
          this.router.navigate(['/'])
        } */
    })
  }

  get isNewProject() {
    return this.tp == 'newProject'
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/admin-page/admin-page.component.ts